import { OpenHandler } from '@theia/core/lib/browser';
import { inject, injectable } from '@theia/core/shared/inversify';
import URI from '@theia/core/lib/common/uri';
import { SettingsContribution } from './settings-contribution';

/** Keeps `preference:` links inside the settings overlay instead of opening a main-shell tab. */
@injectable()
export class SettingsPreferenceOpenHandler implements OpenHandler {
    readonly id: string = 'settings-preference-open-handler';

    @inject(SettingsContribution)
    protected readonly settingsContribution!: SettingsContribution;

    canHandle(uri: URI): number {
        return uri.scheme === 'preference' ? 600 : 0;
    }

    async open(uri: URI): Promise<boolean> {
        const preferenceId: string = uri.path.toString().replace(/^\//, '');
        return this.settingsContribution.navigateToPreference(preferenceId);
    }
}
